import React from 'react';
import { styled } from '@linaria/react';
import { PrimaryOffer } from 'components/Offer/Primary';
import { SecondaryOffer } from 'components/Offer/Secondary';
import { getHighestVisiblePrice } from 'utils/offers';
import { Divider } from '@daedalus/atlas/Divider';
import { SearchOffer } from '@daedalus/core/src/offer/types/SearchOffer';
import { SelectedBanner } from './SelectedBanner';
interface Props {
  offers: SearchOffer[];
  sourceComponent: string;
  hotelId: string;
}
const OffersWrapper = /*#__PURE__*/styled('div')({
  name: "OffersWrapper",
  class: "o19x1byl",
  propsAsIs: false
});
const PrimaryOfferWrapper = /*#__PURE__*/styled('div')({
  name: "PrimaryOfferWrapper",
  class: "p1mfr0rj",
  propsAsIs: false
});
export const OffersList = ({
  offers,
  sourceComponent,
  hotelId
}: Props) => {
  const highestPrice = getHighestVisiblePrice(undefined, offers, false);
  const anchorPrice = highestPrice === offers[0].nightlyRate ? undefined : highestPrice;
  return <OffersWrapper>
      <SelectedBanner />
      <PrimaryOfferWrapper data-id="PrimaryOffer">
        <PrimaryOffer variant="PrimaryMultiColumn" hotelId={hotelId} offer={offers[0]} anchorPriceTotal={anchorPrice} anchorPrice={anchorPrice} hasInteraction sourceComponent={sourceComponent} />
      </PrimaryOfferWrapper>

      {offers.slice(1, 3).map((offer, index) => <div key={offer.id}>
          <Divider sideMargin="s400" />
          <SecondaryOffer variant="SecondaryDefault" hotelId={hotelId} offer={offer} anchorPrice={anchorPrice} anchorPriceTotal={anchorPrice} hasInteraction sourceComponent={sourceComponent} offerPosition={index + 1} />
        </div>)}
    </OffersWrapper>;
};

require("./OffersList.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./OffersList.tsx");